module.exports = __webpack_public_path__ + "media/images/busIcon-d98de8ccc19b62898bbadc92d966fa16.svg";